import { RouteComponent } from "react-router";
import { RouteHelper, ParametrizedRouteFragment, NestedRouteFragment } from "../Imports";

/* eslint-disable @typescript-eslint/no-unused-vars */
export abstract class RouteFragment {
    public parent: RouteFragment;

    public indexComponent: RouteComponent;

    public indexRedirectUrl: string;

    public children: RouteFragment[] = [];

    public component: RouteComponent;

    protected route: string;
    constructor(component: RouteComponent, indexComponent?: RouteComponent | string) {
        this.component = component;

        if (typeof indexComponent === "string") {
            this.indexRedirectUrl = indexComponent.toLocaleLowerCase();
        } else {
            this.indexComponent = indexComponent;
        }
    }

    public getRoute(): string {
        return RouteHelper.toLowerCaseExceptParameters(this.route);
    }

    public registerChild(child: RouteFragment): void {
        this.children.push(child);
    }

    public getFullRoutePath(): string {
        if (this.parent) {
            return this.parent.getFullRoutePath() + "/" + this.getRoute();
        }

        return this.getRoute();
    }

    public getUrl(): string {
        if (this.parent) {
            return this.parent.getUrl() + "/" + this.formatUrl();
        }

        return this.formatUrl();
    }

    protected createParamPage<TParams>(
        route: string,
        component: RouteComponent,
        indexComponent?: RouteComponent | string
    ): (params: TParams) => ParametrizedRouteFragment<TParams> {
        const result = (params: TParams) => new ParametrizedRouteFragment<TParams>(route, params, component, this);
        result(null);
        return result;
    }

    protected createCustomParamPage<TParams, TRouteFragment extends ParametrizedRouteFragment<TParams>>(
        route: string,
        component: RouteComponent,
        classConstructor: new (
            route: string,
            parameters: any,
            component: RouteComponent,
            parent: RouteFragment,
            indexComponent?: RouteComponent | string
        ) => TRouteFragment,
        indexComponent?: RouteComponent | string
    ): (params: TParams) => TRouteFragment {
        if (!classConstructor) {
            classConstructor = ParametrizedRouteFragment as any;
        }

        const result = (params: TParams) => new classConstructor(route, params, component, this, indexComponent);
        result(null);
        return result;
    }

    protected createPage(
        route: string,
        component: RouteComponent,
        indexComponent?: RouteComponent | string
    ): NestedRouteFragment {
        return new NestedRouteFragment(route, component, this, indexComponent);
    }

    protected createCustomPage<TRouteFragment extends NestedRouteFragment>(
        route: string,
        component: RouteComponent,
        classConstructor: new (
            route: string,
            component: RouteComponent,
            parent: RouteFragment,
            indexComponent?: RouteComponent | string
        ) => TRouteFragment,
        indexComponent?: RouteComponent | string
    ): TRouteFragment {
        if (!classConstructor) {
            classConstructor = NestedRouteFragment as any;
        }

        return new classConstructor(route, component, this, indexComponent);
    }

    protected abstract formatUrl(): string;
}
